/**
 * Calculate punch bounding box and velocity.
 */
AFRAME.registerComponent('punch', {
  schema: {
    enabled: {default: false}
  },

  init: function () {
    this.currentPos = new THREE.Vector3();
    this.direction = 0;
    this.lastSample = new THREE.Vector3();
    this.lastSampleTime = 0;
    this.speed = 0;

    this.bbox = new THREE.Box3();
    this.bboxEl = this.el.querySelector('.punchBbox');
  },

  play: function () {
    this.rig = this.el.closest('#curveFollowRig');
  },

  tick: function (time, dt) {
    if (!this.data.enabled) { return; }

    // Calculate velocity (direction + speed), m/s.
    this.direction = this.currentPos
      .copy(this.el.object3D.position)
      .sub(this.lastSample);

    this.speed = this.direction.length() / ((time - this.lastSampleTime) / 1000);

    this.lastSample.copy(this.el.object3D.position);
    this.lastSampleTime = time;
  },

  tickBeatSystem: function () {
    // Bounding box.
    this.bbox.setFromObject(this.bboxEl.getObject3D('mesh'));
  },

  checkCollision: (function () {
    const box = new THREE.Box3();
    const expand = new THREE.Vector3(0, 0, 0.2);

    return function (beat) {
      box.copy(beat.bbox).translate(beat.el.object3D.position).expandByScalar(0.1).expandByVector(expand);
      return this.bbox.intersectsBox(box);
    };
  })()
});
if (module.hot && window.AFRAME) {
  const componentNames = ['punch',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
